import { registerListener } from "./useListeners";

const mouseupKey = "mouseup";
const useMouseupListener = registerListener(window, mouseupKey);

export { useMouseupListener };
